import {createAsyncThunk} from '@reduxjs/toolkit';
import api from 'services/axios';

export const checkChortkeAvailability = createAsyncThunk<any, any>(
  'checkChortkeAvailabilityFromApi',
  async ({vendorId}: any) => {
    const {data} = await api.get(`/chortkeh/check-availability?VendorId=${vendorId}`, {
      goBaseUrl: true
    });
    return data.data;
  }
);

export const getAssortmentRegion = createAsyncThunk<any, any>(
  'getAssortmentRegionFromApi',
  async ({vendorId}: any) => {
    const {data} = await api.get(`/chortkeh/area-top-sales?VendorId=${vendorId}`, {
      goBaseUrl: true
    });
    return data.data;
  }
);

export const getAssortmentVendor = createAsyncThunk<any, any>(
  'getAssortmentVendorFromApi',
  async ({vendorId}: any) => {
    const {data} = await api.get(`/chortkeh/vendor-top-sales?VendorId=${vendorId}`, {
      goBaseUrl: true
    });
    return data.data;
  }
);

export const getProductsPriceTracking = createAsyncThunk<any, any>(
  'getProductsPriceTracking',
  async ({vendorId}: any) => {
    const {data} = await api.get(`/chortkeh/products-price-tracking?vendor_id=${vendorId}`, {
      goBaseUrl: true
    });
    return data.data;
  }
);
